import { canAccessSamplePack, SamplePack } from '@arpeggi/shared'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useAuth } from '../../../__legacy__/hooks/useAuth'

export const useShowUploadDownload = (sp: SamplePack, isHolder: boolean) => {
  const flags = useFlags<{ uploadDownloadFlows?: { samplePackIds?: number[] } }>()
  const { user } = useAuth()
  const uploadDownloadVisible = canAccessSamplePack(sp, isHolder, user)
  const showUploadDownload =
    flags.uploadDownloadFlows?.samplePackIds?.includes(sp.id) && uploadDownloadVisible

  return showUploadDownload
}
